module.exports = __webpack_public_path__ + "51e6ce8e15aa251d0355cbc10de7999f.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/macha-main-320.webp
// module id = 455
// module chunks = 0